export default "__VITE_ASSET__fJ_I4pLt__"